export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उफ़, कोई त्रुटि हुई!"])}
}